import { useCheckDiplomaInfoQuery, useLazyCheckDiplomaInfoQuery, useGetDiplomaListQuery } from '../diplomaApi';

export const useDiplomaInfo = (code) => {
  return useCheckDiplomaInfoQuery({ code }, {
    skip: !code,
    selectFromResult: ({ data, isFetching, isLoading, isError }) => ({
      diplomaInfo: data,
      isFetching,
      isLoading,
      isError,
    }),
  });
};

export const useLazyDiplomaInfo = () => {
  const [checkDiplomaInfo, result] = useLazyCheckDiplomaInfoQuery();
  
  return [
    checkDiplomaInfo,
    {
      diplomaInfo: result.data,
      isFetching: result.isFetching,
      isLoading: result.isLoading,
      isError: result.isError,
    }
  ];
};

export const useDiplomaList = () => {
  return useGetDiplomaListQuery(undefined, {
    selectFromResult: ({ data, isFetching, isLoading, isError }) => ({
      diplomas: data ?? [],
      isFetching,
      isLoading,
      isError,
    }),
  });
};

export const useDiploma = (id) => {
  const { diplomas } = useDiplomaList();
  return diplomas.find(diploma => diploma.id === id);
};
